/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { Storage } from 'aws-amplify';
import { s3Config } from '../../../s3Config';
import PropTypes from 'prop-types';
import { withRoomContext } from '../../../RoomContext';
import * as roomActions from '../../../store/actions/roomActions';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import Viewfiles from '../viewDocument/viewDoc';
import './styles.css';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getWebinarDetals } from '../../../libs/apis/webinarApi';
import { useIntl } from 'react-intl';

Storage.configure({ bucket: s3Config.s3.inapiBucket, region: s3Config.s3.REGION });

// const useStyles = makeStyles((theme) => ({
// 	textField : {
// 		'& .MuiFilledInput-root' : {
// 			backgroundColor : 'white'
// 		},
// 		'& .MuiFilledInput-inputMarginDense' : {
// 			padding : '12px'
// 		}
// 	}
// }));

const DocumentPopup = ({ roomClient, open, setOpen, webinarDetails }) =>
{

	const [ view, setView ] = useState(false);
	const [ fileSelected, setFileSelected ] = useState(null);
	const [ progress, setProgress ] = useState(false);
	const [ proIndex, setProIndex ] = useState('');

	// const [ documentList, setDocumentList ]=useState([ { name: 'surya', size: 789080, url: 'https://invc2023uploads.s3.ap-south-1.amazonaws.com/public/attachmentFiles/1700198457103Electrum-Frontend%20Assignment.pdf' }, { name: 'surya', size: 789080, url: 'https://invc2023uploads.s3.ap-south-1.amazonaws.com/public/attachmentFiles/1700198457103Electrum-Frontend%20Assignment.pdf' } ]);
	const [ documentList, setDocumentList ] = useState(
		webinarDetails.attachmentURL
		// [
		// 	{ url: 'https://invc2023uploads.s3.ap-south-1.amazonaws.com/public/webinarAttachments/17025322669091_-_GRT_inShop_-_Case_Study.docx', name: '1_-_GRT_inShop_-_Case_Study.docx' },
		// 	{ url: 'https://invc2023uploads.s3.ap-south-1.amazonaws.com/public/webinarAttachments/1702532225672teacher_sample_excel_2.xlsx', name: 'teacher_sample_excel_2.xlsx' },
		// 	{ url: 'https://invc2023uploads.s3.ap-south-1.amazonaws.com/public/webinarAttachments/1702532298238DSA_100.pdf', name: 'DSA_100.pdf' },
		// 	{ url: 'https://invc2023uploads.s3.ap-south-1.amazonaws.com/public/webinarAttachments/1702532377989inVC - Google Chrome 2023-11-08 18-05-09.mp4', name: 'inVC - Google Chrome 2023-11-10 10-23-57.mp4' }
		// ]
	);

	// console.log('webinarDetails:::::::::', webinarDetails);

	const intl = useIntl();

	const handleClose = () =>
	{
		setOpen(!open);
	};

	const handleDownloadLocal = async (item, index) =>
	{
		setProgress(true);
		setProIndex(index);
		await roomClient.handleDownload(item.url, item.name);
		setProgress(false);
	};

	const getWebinar = async () =>
	{

		try
		{
			const webinarDataRes = await getWebinarDetals(webinarDetails._id);

			setDocumentList(webinarDataRes.data[0].attachmentURL);

		}
		catch (e)
		{
			console.log('err', e);
		}
	};

	useEffect(() =>
	{
		getWebinar();
	}, []);

	const formatSize = (size) =>
	{
		if (size < 1024 * 1024)
		{
			// Size is less than 1 MB, display in KB
			return `${(size / 1024).toFixed(2)} KB`;
		}
		else
		{
			// Size is 1 MB or more, display in MB
			return `${(size / (1024 * 1024)).toFixed(2)} MB`;
		}
	};

	return (
		<div className='flexCol dialogBD'>
			<div className='flexCol dialogBox docHdrHg'>
				<div className='flexRow jBtwn aCntr brdrBSM pdngSM'>
					<div className='flexMinWidthRow pdngHXS'>
						<span className='mHdng'>Documents</span>
					</div>
					<div className='flexAutoRow'>
						<img
							src='/images/cancel.svg'
							alt='cancel'
							className='IconImage pointer'
							onClick={() => handleClose()}
						/>
					</div>
				</div>
				<div className='flexCol pdngXS docBodyHg'>
					{documentList && documentList.length > 0 ? documentList.map((item, index) =>
						(<div className='flexRow pdngXS' key={index}>
							<div className='flexMinWidthRow gap16 pointer' onClick={() => { setView(true); setFileSelected(item); }}>
								<div className='flexAutoRow'>
									<img className='iSize' alt='pdf' src={`/documents/${item?.name?.split('.')?.slice(-1)[0]}.png`} />
								</div>
								<div className='flexMinWidthCol '>
									<span className='ellipse'>{item.name}</span>
									{/* <span>{(item.size / (1024 * 1024)).toFixed(2)}MB</span> */}
									<span>{formatSize(item.size)}</span>
								</div>
							</div>
							<div className='flexAutoRow gap8 aCntr pdngTSM'>
								{/* <span className='flexAutoRow link sHdng' onClick={() => { setView(true); setFileSelected(item); }}>View</span> */}

								{(proIndex === index && progress) ? <div className='flexAutoRow'>
									{/* <LinearProgress style={{ height: '8px', borderRadius: '4px' }} /> */}
									<CircularProgress
										size='1.5rem'
									// style={{ height: '12px', width: '12px', borderRadius: '50%' }}
									/>
								</div> :<img src='/icons/download.svg' alt='download' onClick={() => handleDownloadLocal(item, index)}/>

								//  <span className='flexAutoRow link sHdng' onClick={() => handleDownloadLocal(item, index)}>Download</span>
								}

							</div>
							{/* <img src='/public/icons/downVote.svg' alt='download' onClick={() => handleDownloadLocal(item, index)}/> */}
							{/* {console.log('proIndex and progress', proIndex, index, progress)}
							{(proIndex === index && progress) && <div className='flexMinWidthCol'>
								<LinearProgress style={{ height: '8px', borderRadius: '4px' }} />
							</div>} */}
						</div>)
					)
						: <div className='flexMinWidthCol gap16 aCntr jCntr'>
							<img src='/images/noUpload.svg' alt='noUpload' />
							<span>
								{
									intl.formatMessage({
										id             : 'no_Recent_files',
										defaultMessage : 'No Recent Files. Files are retained only for the duration of this session.'
									})
								}
							</span>
						</div>}
				</div>
			</div>
			{view &&
				<Viewfiles view={view} setView={setView} fileSelected={fileSelected} />
			}
		</div>
	);
};

DocumentPopup.propTypes =
{
	roomClient     : PropTypes.object.isRequired,
	open           : PropTypes.bool,
	setOpen        : PropTypes.func,
	// me             : PropTypes.any,
	webinarDetails : PropTypes.any

};

const makeMapStateToProps = () =>
{
	const mapStateToProps = (state) =>
		({
			room           : state.room,
			// me             : state.me,
			webinarDetails : state.webinar.webinarData

		});

	return mapStateToProps;
};

const mapDispatchToProps = (dispatch) =>
	({
		setToolbarsVisible : (visible) =>
		{
			dispatch(roomActions.setToolbarsVisible(visible));
		}
	});

export default withRoomContext(connect(
	makeMapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room
			);
		}
	}
)(DocumentPopup));